import {FormModel} from 'components/Form';
import {discountType} from 'utils/constants/data';
import {Validators} from 'utils/validators';

export const AddEditBookingAddOnForm = (
    strings: any,
    dropdownData: { label: string; value: string }[],
    isEdit: boolean,
    discountDisabled: boolean,
    addOnCategories: any[],
): FormModel[] => {
    return [
        {
            label: strings.addOnCategory,
            value: '',
            size: 'medium',
            type: 'select',
            typeValue: 'text',
            placeholder: '',
            field: 'addOnCategory',
            validators: [{check: Validators.validateMandatoryField}],
            required: true,
            responsive: {xs: 12},
            options: addOnCategories,
            disabled: isEdit,
        },
        {
            label: strings.addOnName,
            value: '',
            size: 'medium',
            type: 'select',
            placeholder: strings.addOnName,
            field: 'bookedAddOnId',
            validators: [{check: Validators.validateMandatoryField}],
            responsive: {xs: 12},
            required: true,
            options: dropdownData,
            disabled: isEdit,
            isMulti: false,
        },
        {
            label: strings.actualQuantity,
            value: '',
            size: 'medium',
            type: 'text',
            typeValue: 'number',
            placeholder: '',
            field: 'actualQuantity',
            validators: [{check: Validators.validateMandatoryField}, {check: Validators.validateInt}],
            required: true,
            responsive: {xs: 12},
        },
        {
            label: strings.initialQuantity,
            value: '',
            size: 'medium',
            type: 'text',
            typeValue: 'number',
            placeholder: '',
            field: 'quantity',
            validators: [],
            required: false,
            responsive: {xs: 12},
            disabled: true,
        },
        {
            label: strings.addOnType,
            value: '',
            size: 'medium',
            type: 'text',
            typeValue: 'text',
            placeholder: '',
            field: 'addOnType',
            validators: [{check: Validators.validateString, max: 100}],
            required: false,
            responsive: {xs: 12},
            disabled: true,
        },
        {
            label: strings.addOnHsnCode,
            value: '',
            size: 'medium',
            type: 'text',
            typeValue: 'text',
            placeholder: strings.addOnHsnCode,
            field: 'hsnCode',
            validators: [],
            required: false,
            responsive: {xs: 12},
            disabled: true,
        },
        {
            label: strings.price,
            value: '',
            size: 'medium',
            type: 'text',
            typeValue: 'number',
            placeholder: '',
            field: 'price',
            validators: [],
            required: false,
            responsive: {xs: 12},
            disabled: true,
        },
        {
            label: strings.taxGroup,
            value: '',
            size: 'medium',
            type: 'select',
            placeholder: strings.taxGroup,
            field: 'taxGroup',
            validators: [],
            responsive: {xs: 12},
            required: false,
            isMulti: false,
            disabled: true,
        },
        {
            label: strings.discountType,
            value: '',
            size: 'medium',
            type: 'drop-down',
            placeholder: '',
            field: 'discountType',
            validators: [],
            responsive: {xs: 6},
            required: false,
            options: discountType(strings),
        },
        {
            label: strings.discount,
            value: '',
            size: 'medium',
            type: 'text',
            typeValue: 'number',
            placeholder: '',
            field: 'discount',
            validators: [],
            required: false,
            responsive: {xs: 6},
            disabled: discountDisabled,
        },
    ];
};
